import './cooknsolo/style';
import FormStructure from './cooknsolo/form_structure';

export default FormStructure;